import Marionette from 'backbone.marionette';
import WatchedBillItemview from './watchedbill_itemview';
export default Marionette.CollectionView.extend({
  childView: WatchedBillItemview,
  tagName: "div",
  className: "c-bill-list"
});